// extracted by mini-css-extract-plugin
export default {"footerLinks":"c-e_cT"};